import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { LoginComponent } from './auth/login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { HomeComponent } from './home/home.component';
import { ReassignFieldsComponent } from './reassign-fields/reassign-fields.component';
import { MainLayoutComponent } from './shared/layout/main-layout/main-layout.component';
import { RoleGuardService } from './shared/role-guard.service';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: '', component: MainLayoutComponent, canActivate: [MsalGuard], children: [
      { path: 'home', component: HomeComponent, canActivate: [MsalGuard, RoleGuardService], data: { expectedRole: ['Administrator', 'Member','Operator'] } },
      { path: 'dashboard', component: DashboardComponent, canActivate: [MsalGuard, RoleGuardService], data: { expectedRole: ['Administrator','Operator'] } },
      { path: 'reassign', component: ReassignFieldsComponent, canActivate: [MsalGuard, RoleGuardService], data: { expectedRole: ['Administrator','Operator'] } }
    ]
  },
  { path: '**', redirectTo: 'login' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
